import luckysheetConfigsetting from '../controllers/luckysheetConfigsetting';
import Store from '../store';

export const error = {
    v: "#VALUE!",    //错误的参数或运算符
    n: "#NAME?",     //公式名称错误
    na: "#N/A",      //函数或公式中没有可用数值
    r: "#REF!",      //删除了由其他公式引用的单元格
    d: "#DIV/0!",    //除数是0或空单元格
    nm: "#NUM!",     //当公式或函数中某个数字有问题时
    nl: "#NULL!",    //交叉运算符（空格）使用不正确
    sp: "#SPILL!"    //数组范围有其它值
}

//是否是空值
function isRealNull(val) {
    if(val == null || val.toString().replace(/\s/g, "") == ""){
        return true;
    }
    else{
        return false;
    }
}

//是否是纯数字
function isRealNum(val) {
    if(val == null || val.toString().replace(/\s/g, "") === ""){
        return false;
    }

    if(typeof val == "boolean"){
        return false;
    }

    if(!isNaN(val)){
        return true;
    }
    else{
        return false;
    }
}

//是否是错误类型
function valueIsError(value) {
    let isError = false;

    for(let x in error){
        if(value == error[x]){
            isError = true;
            break;
        }
    }

    return isError;
}

//是否有中文
function hasChinaword(s) {
    let patrn = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
    
    if (!patrn.exec(s)) {
        return false;
    }
    else {
        return true;
    }
}

//是否为非编辑模式
function isEditMode() {
    if(luckysheetConfigsetting.editMode){
        return true;
    }
    else{
        return false;
    }
}

/**
 * @description: 检查是否允许前台进行表格编辑
 * @param {*}
 * @return {Boolean} true:允许编辑 fasle:不允许
 */
function checkIsAllowEdit(){
    if (Store.allowEdit) {
        return true;
    }
    else {
        return false;
    }
}

//范围是否只包含部分合并单元格
function hasPartMC(cfg, r1, r2, c1, c2) {
    let hasPartMC = false;

    for(let x in Store.config["merge"]){
        let mc = cfg["merge"][x];

        if(r1 < mc.r){
            if(r2 >= mc.r && r2 < (mc.r + mc.rs - 1)){
                if(c1 >= mc.c && c1 <= (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c2 >= mc.c && c2 <= (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c1 < mc.c && c2 > (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
            }
            else if(r2 >= mc.r && r2 == (mc.r + mc.rs - 1)){
                if(c1 > mc.c && c1 < (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c2 > mc.c && c2 < (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c1 == mc.c && c2 < (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c1 > mc.c && c2 == (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
            }
            else if(r2 > (mc.r + mc.rs - 1)){
                if(c1 > mc.c && c1 <= (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c2 >= mc.c && c2 < (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c1 == mc.c && c2 < (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c1 > mc.c && c2 == (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
            }
        }
        else if(r1 == mc.r){
            if(r2 < (mc.r + mc.rs - 1)){
                if(c1 >= mc.c && c1 <= (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c2 >= mc.c && c2 <= (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c1 < mc.c && c2 > (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
            }
            else if(r2 >= (mc.r + mc.rs - 1)){
                if(c1 > mc.c && c1 <= (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c2 >= mc.c && c2 < (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c1 == mc.c && c2 < (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
                else if(c1 > mc.c && c2 == (mc.c + mc.cs - 1)){
                    hasPartMC = true;
                    break;
                }
            }
        }
        else if(r1 <= (mc.r + mc.rs - 1)){
            if(c1 >= mc.c && c1 <= (mc.c + mc.cs - 1)){
                hasPartMC = true;
                break;
            }
            else if(c2 >= mc.c && c2 <= (mc.c + mc.cs - 1)){
                hasPartMC = true;
                break;
            }
            else if(c1 < mc.c && c2 > (mc.c + mc.cs - 1)){
                hasPartMC = true;
                break;
            }
        }
    }

    return hasPartMC;
}

//获取单个字符的字节数
function checkWordByteLength(value) {
    return Math.ceil(value.charCodeAt().toString(2).length / 8);
 }
function vaildRange(typeVal) {
  let checkRange = luckysheet.getRange()[0]
  let {borderInfo} = luckysheet.getConfig()
  let off = false
  let rangId = null
  if(borderInfo != null && borderInfo.length){
    borderInfo.map((item)=>{
      if(item.rangId){
        let isInSelection  = isRangeInSelection(checkRange, item.range[0], typeVal)
        if(isInSelection){
          rangId = item.rangId
          off = true
        }
      }
    })
  }
  return {off, rangId}
}
function vaildCellRangeData(rangeValue) {
 let off = false
 // 遍历二维数组，输出每个单元格的值
  for (var row = 0; row < rangeValue.length; row++) {
    for (var col = 0; col < rangeValue[row].length; col++) {
      var cellValue = rangeValue[row][col];
      if(cellValue.v){
        off = true
        break
      }
      if(cellValue.m){
        off = true
        break
      }
      if(cellValue.form){
        off = true
        break
      }
      // console.log("单元格的值：", cellValue);
    }
  }
  return {off}
}
function getNumArr (min,max){
  let arr = []
  for (let i = min; i <= max; i++) {
    arr.push(i)
  }
  return arr
}
function vaildNum(currentRange, selectedRange){
  let currentRowArr = getNumArr(currentRange.row[0], currentRange.row[1])
  let currentColArr = getNumArr(currentRange.column[0], currentRange.column[1])
  let selectRowArr = getNumArr(selectedRange.row[0], selectedRange.row[1])
  let selectColArr = getNumArr(selectedRange.column[0], selectedRange.column[1])
  let num = 0
  let off = false
  if(currentRowArr.some(item => selectRowArr.includes(item))){
    num += 1
  }
  if(currentColArr.some(item => selectColArr.includes(item))){
    num += 1
  }
  if(num >= 2){
    off = true
  }
  return off
}
function vaildOneNum(currentRange, selectedRange){
  let currentRowArr = getNumArr(currentRange[0], currentRange[1])
  let selectRowArr = getNumArr(selectedRange[0], selectedRange[1])
  let num = 0
  let off = false
  if(currentRowArr.some(item => selectRowArr.includes(item))){
    num += 1
  }
  if(num >= 1){
    off = true
  }
  return off
}
/**
 * 
 * @param {Object} currentRange 当前选区
 * @param {Object} selectedRange 查询选区
 * @param {String} val contain：选区包含； in:选区内;
 * @returns 
 */
function isRangeInSelection(currentRange, selectedRange, val = 'contain'){
  // console.log('currentRange',currentRange)
  // console.log('selectedRange',selectedRange)
  let isInSelection = false
  if(val === 'contain'){
    isInSelection = vaildNum(currentRange, selectedRange)
  }else if(val === 'in'){
    if ( currentRange.row[0] >= selectedRange.row[0] && currentRange.row[1] <= selectedRange.row[1] && currentRange.column[0] >= selectedRange.column[0] && currentRange.column[1] <= selectedRange.column[1] ) {
      isInSelection = true;
    }
  }
  return isInSelection
}
/**
 * 
 * @param {*} type row 操作行；column 操作列
 * @param {*} index 
 */
function vaildCr(type, index){
  let {borderInfo} = luckysheet.getConfig()
  let off = false
  if(borderInfo != null && borderInfo.length){
    borderInfo.map((item)=>{
      let valType = ''
      if(item.form){
        if(item.form.gdType == 1){
          valType = item.form.childType
        }
      }
      if(item.form && item.rangId && type === valType){
        let arr = getNumArr(item.range[0][type][0], item.range[0][type][1])
        let offIndex = arr.findIndex((v)=>v == index)
        if(offIndex > -1){
          off = true
          
        }
      }
    })
  }
  return off
}
/**
 * 
 * @param {*} rangeArr 当前表格选区
 * @param {*} type 
 * @returns 
 */
function vaildRangeInsert(rangeArr, type = 'row'){
    if(rangeArr && rangeArr.length <= 0) return
    let rangeRow = rangeArr[0]
    let {borderInfo} = luckysheet.getConfig()
    let off = false
    if(borderInfo != null && borderInfo.length){
      borderInfo.map((item)=>{
        if(item.form){
          if(item.form.gdType == 1){ // 固定行
            if(vaildOneNum(rangeRow[type], item.range[0][type])){
              off = true
            }
          }
        }
      })
    }
    return(off)
  
}
function updateChild(){
  let currentSheetIndex = luckysheet.getActiveSheetIndex()
  console.log(luckysheet.getAllSheets())
  let currentData = luckysheet.getAllSheets()[currentSheetIndex].data
  let {borderInfo} = luckysheet.getConfig()
  if(!borderInfo) return
  for(let i = 0; i < currentData.length; i++){
    for(let j = 0; j < currentData.length; j++){
      borderInfo.map((item)=>{
        if(item.form){
          let offs = isRangeInSelection({row:[i,i], column: [j,j]}, item.range[0], 'in')
          if(offs){ // 当前单元格处于子表单内
            if(item.form.childType == 'column'){
              let topCell = ''
              let botCell = ''
              if(i >= 1 && isRangeInSelection({row:[i-1,i-1], column: [j,j]}, item.range[0], 'in')){
                if(currentData[i-1][j] && currentData[i-1][j].form){
                  topCell = currentData[i-1][j]
                }
              }
              if(isRangeInSelection({row:[i+1,i+1], column: [j,j]}, item.range[0], 'in')){
                if(currentData[i+1][j] && currentData[i+1][j].form){
                  botCell = currentData[i+1][j]
                }
              }
              if(topCell || botCell){
                let valCell = topCell || botCell
                delete valCell.v
                delete valCell.m
                luckysheet.setCellValue(i, j, valCell)
              }
            }
            if(item.form.childType == 'row'){
              let leftCell = ''
              let rightCell = ''
              if(i >= 1 && isRangeInSelection({row:[i,i], column: [j-1,j-1]}, item.range[0], 'in')){
                if(currentData[i][j-1] && currentData[i][j-1].form){
                  leftCell = currentData[i][j-1]
                }
              }
              if(i >= 1 && isRangeInSelection({row:[i,i], column: [j+1,j+1]}, item.range[0], 'in')){
                if(currentData[i][j+1] && currentData[i][j+1].form){
                  rightCell = currentData[i][j+1]
                }
              }
              if(leftCell || rightCell){
                let valCell = leftCell || rightCell
                delete valCell.v
                delete valCell.m
                luckysheet.setCellValue(i, j, valCell)
              }
            }
          }
        }
        
      })
    }
  }
}
export {
    isRealNull,
    isRealNum,
    valueIsError,
    hasChinaword,
    isEditMode,
    checkIsAllowEdit,
    hasPartMC,
    checkWordByteLength,
    vaildRange,
    vaildCr,
    vaildCellRangeData,
    updateChild,
    vaildRangeInsert
}